import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Chip, Box } from "@mui/material";
import locationContext from "../../../app/providers/location/locationContext";
import filterContext from "../../../app/providers/filter/filterContext";
import orderByContext from "../../../app/providers/orderBy/orderByContext";
import carBrandContext from "../../../app/providers/car-brands/carBrandContext";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import OrderByFilter from "./OrderByFilter";
import { defaultLocation } from "../../../app/store/workshopSlice";
import { useSelector } from "react-redux";
import { useGetWorkshopsQuery } from "../../../app/store/api/workshopApi";

export default function CountAndOrderBy() {
  const { t, i18n } = useTranslation();
  const { state : locationState } = useContext(locationContext);
  const { state : filterState, setFilter } = useContext(filterContext);
  const { state : orderByState, setOrderBy } = useContext(orderByContext);
  const { state: carBrandState } = useContext(carBrandContext);
  const storedDefaultLocation = useSelector(defaultLocation);
  const draftCar = useSelector((state) => state.reservation.draft.car);
  const location = locationState.location || storedDefaultLocation;
  const filter = filterState.filter || [];
  const selectedCar = draftCar || carBrandState.brand;
  const {data:workshopsList,isLoading:loading} = useGetWorkshopsQuery({ location, filter, car: selectedCar });
  const [ extraServices, setExtraServices ] = useState([]);
  const [ extraServiceLoading, setExtraServiceLoading ] = useState(true);

  const {isMobile} = useWindowSize()

  useEffect(() => {
    createExtraServiceList();
  }, [filterState.filter]);

  const createExtraServiceList = () => {
    if (Array.isArray(filterState.filter)) {
      setExtraServices(filterState.filter.filter(filter => filter.headerName === 'extraServices')[0]?.services || []);
      setExtraServiceLoading(false);
    }
  }

  const handleChange = (option) => {
    setOrderBy(option.value);
  };

  const extraServiceClicked = (id) => {
    // Toggle "active" flag for this service only
    const updatedFilter = filterState.filter.map(filter => {
      if (filter.headerName === 'extraServices') {
        const updatedServices = filter.services.map(service => {
          if (service.id === id) {
            return { ...service, active: !service.active };
          }
          return service;
        });
        return { ...filter, services: updatedServices };
      }
      return filter;
    });
    setFilter(updatedFilter);
  };


  while (extraServiceLoading) {
    return null;
  }

  return (
    <Box className="count-and-order-by" 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        padding: "16px",
        backgroundColor: "#dcffff",
      }}
    
    >
      <Box className={isMobile ? "count-and-order-by-top-nonDesktop" : "count-and-order-by-top"}>
        <Box sx={{ display: "flex", alignItems: "center", width:"100%" }}>
          <Typography variant="body2" component="span" className="accent-color-dark" sx={{ width:"40px",height:"40px",marginRight: "8px", fontWeight: "bold",border:"2px solid #003C59",padding:"8px",borderRadius:"50%",textAlign:"center" }}>
            {workshopsList?.length ?? 0}
          </Typography>
          <Box sx={{ width:"95%", display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "flex-start" : "center", justifyContent: "space-between", gap: isMobile ? 1 : 0 }}>
            <Typography variant="body2" component="span" sx={{ fontWeight: "bold" }}>
              {t("orderBy.results")} • {t("orderBy.nearBy")}
              {/* {t("orderBy.results")} • {t("orderBy.nearBy")} {locationState?.locationAddress?.city || 'Helsinki'} */}
            </Typography>
            <OrderByFilter selectedOrderBy={orderByState.orderBy} handleChange={handleChange} />
          </Box>
        </Box>
      </Box>
      {/* <Typography variant="body2" sx={{ marginTop: "8px", fontWeight: "bold" }}>
        {t("extraServices.extraServices")}:
      </Typography> */}
      <Box>
        { extraServices?.map(service => (
          <Chip 
            key={service.id} 
            label={service.translations[i18n.language].name} 
            variant={service.active ? "filled" : "outlined"}
            sx={{ 
              marginRight: '4px', 
              marginTop: '4px', 
              // Ensure white background when not active (outlined)
              backgroundColor: service.active ? undefined : '#fff',
              '&:hover': {
                backgroundColor: service.active ? undefined : '#fff'
              }
            }}
            onClick={() => extraServiceClicked(service.id)}
            color="primary"
            
          />
        )) }
      </Box>
    </Box>
  );
}
